/**
 * 通知設定ページ用のスクリプト
 */
var notification_setting_treemultiselect = null;

if (is_route('notification_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        notification_setting_event_set();
        notification_setting_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.notification_setting_event_set = function() {

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['id', 'holding_id']);
    });

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id', 'type', 'holding_id'], false, function() {
            notification_setting_treemultiselect = initialize_treemultiselect();
            const isSectionUser = $('#notification_setting-setting-modal-is_section_user').val();
            // 営業所権限ユーザーで既存モデルの場合
            if (isSectionUser && $('#notification_setting-setting-modal-id').val()) {
                $('#notification_setting-setting-modal-original_section_user_ids').val(JSON.stringify($('#notification_setting-setting-modal-user_ids').val()))
            }
        });
    });

    /*---- 設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
            $('[data-detail-modal=notification_setting-detail-modal][data-id=' + results.notification_setting.id + ']').trigger('click');
        }, function() {
            notification_setting_set_steper_error();
        });
    });

    /*---- 一括削除チェックボックス操作時 ----*/

    // 一括のチェックボックスクリック時
    $(document).on('click', '#notification_setting-all-delete', function () {
        $(".notification_setting-delete").prop('checked', $(this).prop('checked'));
    });
    // 一覧のチェックボックスクリック時
    $(document).on('click', '.notification_setting-delete', function (e) {
        // バブリングを禁止
        e.stopPropagation();
    });
    // 一括・一覧のチェックボックス変更時
    $(document).on('change', '#notification_setting-all-delete, .notification_setting-delete', function () {
        // 一覧のチェック状態を判定し削除ボタンを有効化
        $('#notification_setting-multi-delete-button').prop('disabled', ($('.notification_setting-delete:checked').length == 0));
    });

    /*---- 削除確認時 ----*/

    // 一括削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        var ids = ($(this).data('id') == null ? [] : [$(this).data('id')]);
        if ($(this).data('id') == null) {
            $('.notification_setting-delete[name="ids[]"]:checked').map(function() {
                ids.push($(this).val());
            });
        }
        if (ids.length > 0) {
            _modal.create_with_data(this, 'confirm-modal', {'ids': ids, 'holding_id' : $(this).data('holding_id')});
        }
    });

    /*---- 削除処理 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            _modal.hide('#notification_setting-detail-modal');
        });
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

}
/**
 * 設定モーダル表示時のイベント設定
 */
window.notification_setting_setting_event_set = function() {

    // 送信イベント変更時
    $(document).on('change', '#notification_setting-setting-modal-send_events', function () {
        let value = $(this).val();
        $('.setting-part').each(function() {
            $(this).addClass('display-none');
        });
        value.forEach(function(item) {
            $('.setting-part-'+item).removeClass('display-none');
        });
    });

    /*---- ステップボタンクリック時（新規登録時） ----*/

    // 前へ
    $(document).on('click', '[data-prev-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let prevPart = $(this).data('prev-step');
        let prevPartTrigger = create_id(prevPart + '-trigger');
        let prevPartSubmit = create_id(prevPart + '-submit');
        $(currentPartSubmit).addClass('display-none');
        $(prevPartSubmit).removeClass('display-none');
        bs_step_trigger(prevPartTrigger);
    });

    // 次へ
    $(document).on('click', '[data-next-step]', function () {
        // Partセレクターの指定
        let currentPartSubmit = $(this).parents('.modal-footer');
        let nextPart = $(this).data('next-step');
        let nextPartTrigger = create_id(nextPart + '-trigger');
        let nextPartSubmit = create_id(nextPart + '-submit');
        // ModalとPartセレクターの指定
        let modalId = '#notification_setting-setting-modal';
        let formId = '#notification_setting-setting-modal-form';
        let action = $(formId).data('confirm-action');
        // 確認対象のパートをパラメータにセット
        $('#notification_setting-setting-modal-confirm_step').val($(this).data('confirm-step'));
        // 送信前にエラーをリセット
        _error.reset()
        notification_setting_set_steper_error(false);
        // 確認用のpost送信
        _ajax.confirm_submit(formId, action, function (results) {
            $(currentPartSubmit).addClass('display-none');
            $(nextPartSubmit).removeClass('display-none');
            bs_step_trigger(nextPartTrigger);
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
            // ステップエラーを表示
            notification_setting_set_steper_error();
        });
    });

    // 営業所変更時
    $(document).on('change', 'select.sections-select', function () {
        if ($(this).attr('name') === 'sections_for_notify[]') {
            return false;
        }
        let companyId = $('#notification_setting-setting-modal-company_id').val();
        let sectionIds = $(this).val();
        if (sectionIds.length == 0) {
            $('#notification_setting-setting-modal-form #users-part .selections .section').remove();
            $('#notification_setting-setting-modal-form #users-part .selected').remove();
             $('#notification_setting-setting-modal-user_ids').val([]);
        } else {
            setTreeMultiSelect(this, 'select.users-select', {'company_id': companyId, 'sectionIds': sectionIds, 'otherColumn' : ['section_name', 'company_name'], 'type' : 'has_email_or_tel'});
        }
    });

    // セレクトの値をセットする
    function setTreeMultiSelect(elm, find, datas = {}, callback = null) {
        let select = $(elm).parents('form').find(find);
        if (select.length > 0) {
            let action = $(select).data('action');
            let selectedIds = ($(select).val() || []).map(String);
            _ajax.post(action, datas, function (results) {
                $(select).empty();
                notification_setting_treemultiselect[0][0].remove();
                $.each(results.options, function(index, option) {
                    if(option.id == ''){ return true; }
                    $(select).append($('<option></option>', {
                        'value': option.id,
                        'data-section': option.section_name,
                        'selected' : selectedIds.includes(String(option.id)) ? true : false,
                    }).text(option.text));
                })
                notification_setting_treemultiselect = initialize_treemultiselect();
                if (callback != null) {
                    callback(elm);
                }
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    }

}

/**
 * ステッパーへのエラー表示処理
 * @param {*} showError
 */
window.notification_setting_set_steper_error = function (showError = true) {
    if (showError) {
        $('#base-part-trigger').toggleClass('error', ($('#base-part').find('.invalid-feedback:not(.copy)').length > 0));
        $('#mail-part-trigger').toggleClass('error', ($('#mail-part').find('.invalid-feedback:not(.copy)').length > 0));
    } else {
        $('#base-part-trigger').removeClass('error');
        $('#mail-part-trigger').removeClass('error');
    }
}
